import React from 'react';
import { formats } from '~/helper';
import { Item, TabContainer } from '~/views/partners/styles';

const TabAggrements = (props) => {
  return (
    <TabContainer>
      {props.values &&
        props.values.aggrements &&
        props.values.aggrements.map((value, index) => (
          <Item key={index}>
            <div className='column-data'>
              <div className='first'>
                <strong>{value.who}</strong>
              </div>
              {formats.dateTimeZone(value.createdAt)}
            </div>
          </Item>
        ))}
    </TabContainer>
  );
};

export default TabAggrements;
